<!-- Contents are projected into right place, order doesn't matter here -->

<nchl-layout-one>
  <app-top-bar layout-header></app-top-bar>
  <app-sidebar-top sidebar-top></app-sidebar-top>
  <app-sidebar-middle sidebar-middle></app-sidebar-middle>
  <app-sidebar-bottom sidebar-bottom></app-sidebar-bottom>
  <app-main layout-content></app-main>
  <app-footer layout-footer></app-footer>
</nchl-layout-one>
